// react
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// models
import { Chat } from '@karehero/models';

// components
import { Button, Container, Title } from '@/components/atoms';
import { ConversationCard } from '@/components/molecules/ConversationCard/ConversationCard';

interface ConversationListProps {
  accountID: string;
  chats: Chat[];
  onCreateChat: () => Promise<void>;
}

export const ConversationList = ({
  accountID,
  chats,
  onCreateChat,
}: ConversationListProps) => {
  // hooks
  const navigate = useNavigate();

  return (
    <Container size='lg'>
      <Header>
        <StyledTitle size='sm'>Chats</StyledTitle>
        <Button
          ariaLabel='new chat'
          iconLeft='plus'
          size='sm'
          onPress={() => {
            onCreateChat();
          }}
        >
          New chat
        </Button>
      </Header>
      <ListWrapper>
        {chats.map((chat: Chat) => (
          <ChatItem
            key={chat.id}
            onClick={() => navigate(`/messenger/${chat.id}`)}
          >
            <ConversationCard
              accountID={accountID}
              messages={chat.messages}
              createdAt={chat.messages?.[0]?.formattedCreatedAt || ''}
            />
          </ChatItem>
        ))}
      </ListWrapper>
    </Container>
  );
};

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[8]};
  padding: ${(props) => props.theme.spacing[16]} 0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${(props) => props.theme.spacing[16]};
`;

const StyledTitle = styled(Title)`
  margin: 0;
`;

const ChatItem = styled.div`
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateX(4px);
  }
`;

ConversationList.displayName = 'ConversationList';

export default ConversationList;
